import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  // Bearer-token auth via Authorization header (stored in localStorage).
  // Avoiding cookies keeps CORS simple: works cross-origin AND same-origin
  // without depending on Access-Control-Allow-Credentials.
  withCredentials: false,
});

// Attach bearer token when present (fallback to cookies otherwise).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adlib_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
